export default `
Published by
Native Studios UG (haftungsbeschränkt)
Greifswalder Straße 29
10405 Berlin

Phone +49 30 765 832 72
Fax +49 30 240 881 81
Email info@native-studios.com

Managing Directors
Alex Schwaderer, Johannes Kahnt

Register
Amtsgericht Charlottenburg

Registernumber
HRB 175820 B
`;
